import { Injectable } from '@angular/core';
import { Socket } from 'ngx-socket-io';

@Injectable({
  providedIn: 'root'
})
export class SocketPagosService extends Socket {

  constructor() {
    // super({ url: 'http://gl.solnet.cl:3408', options: {} });
    // super({ url: 'http://localhost:3923', options: {} });
    // super({ url: 'http://localhost:3925', options: {} });
    //super({ url: 'https://nidx.solnet.cl:3923', options: {} }); //PRODUCTIVOO
    // super({ url: 'https://lnxaz02.solnet.cl:3925', options: {} });//test ssl azure
    super({ url: 'https://nidx.solnet.cl:3925', options: {} }); //ssl test
  }

}
